import { useEffect, useState } from "react";

// Reader-selectable languages for the Knowledge Base. The stored articles are
// always English; picking a flag AI-translates the view (see kb_translate.py).
export const KB_ORIGINAL = "original";

export const KB_LANGS = [
  { code: "en-CA", label: "Canadian English", short: "EN-CA", cc: "ca" },
  { code: "en-US", label: "US English", short: "EN-US", cc: "us" },
  { code: "fr", label: "Français", short: "FR", cc: "fr" },
  { code: "es", label: "Español", short: "ES", cc: "es" },
];

const STORAGE_KEY = "kb_lang";
const EVENT = "kb-lang-change";

export function flagUrl(cc) {
  return `https://flagcdn.com/32x24/${cc}.png`;
}

export function langMeta(code) {
  return KB_LANGS.find((l) => l.code === code) || null;
}

export function getKbLang() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v && (v === KB_ORIGINAL || KB_LANGS.some((l) => l.code === v))) return v;
  } catch { /* ignore */ }
  return KB_ORIGINAL;
}

export function setKbLang(code) {
  try { localStorage.setItem(STORAGE_KEY, code); } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: code }));
}

// Shared across the article page and the landing/search so the choice stays in
// sync everywhere and persists across navigation.
export function useKbLang() {
  const [lang, setLang] = useState(getKbLang);
  useEffect(() => {
    const onChange = (e) => setLang(e.detail || getKbLang());
    window.addEventListener(EVENT, onChange);
    return () => window.removeEventListener(EVENT, onChange);
  }, []);
  const choose = (code) => { setKbLang(code); setLang(code); };
  return [lang, choose];
}
